export default __webpack_public_path__ + "static/media/hero@3x.49044fd2.png";